// Sentry SDK filter options shared by the storefront apps: events that are noise rather than actionable errors

export const SENTRY_IGNORE_ERRORS: RegExp[] = [
  // an HttpErrorResponse rejected without a handler; ErrorLoggerHttpInterceptor already reported the request
  /Non-Error exception captured with keys: error, headers, message, name, ok/,
  // Safari throttles history updates
  /history\.(push|replace)State\(\) more than 100 times/,
];

// errors thrown inside third-party scripts loaded on the pages
export const SENTRY_IGNORE_URLS: RegExp[] = [
  /googlesyndication\.com/,
  /googletagmanager\.com/,
  /google-analytics\.com/,
  /connect\.facebook\.net/,
];

// skips automated browsers (crawlers, monitoring, test runners)
export function sentryShouldSendCallback(): boolean {
  if (typeof navigator === 'undefined') {
    return true;
  }

  return !navigator.webdriver && !/HeadlessChrome/.test(navigator.userAgent);
}
